// Rowing figures (Concept2 rower) from what Khronos already has: a 2k
// benchmark and the rower's 1 Hz telemetry.

import { benchmarkAge, isErg, timeForDistance } from "./benchmarkNormalise";

/**
 * VO2max from a 2k time, Concept2's published estimate (concept2.com VO2max
 * calculator): litres per minute from the time in minutes, by sex, weight
 * band (61.36 kg women, 75 kg men) and whether you train regularly, then
 * divided by body weight. Null without what it needs.
 *
 * @returns {null | { value: number, litres: number }}
 */
export function vo2maxFrom2k({ sec, kg, sex, trained = true }) {
  const t = Number(sec) / 60;
  const w = Number(kg);
  if (!(t > 0) || !(w > 0) || (sex !== "male" && sex !== "female")) return null;
  let litres;
  if (sex === "female") litres = trained ? (w > 61.36 ? 14.9 : 14.6) - 1.5 * t : 10.26 - 0.93 * t;
  else litres = trained ? (w > 75 ? 15.7 : 15.1) - 1.5 * t : 10.7 - 0.9 * t;
  if (!(litres > 0)) return null;
  return { value: Math.round(((litres * 1000) / w) * 10) / 10, litres: Math.round(litres * 100) / 100 };
}

/** Your most recent 2000 m rower benchmark, or null. */
export function latest2k(capabilities, now = new Date()) {
  const twoKs = (capabilities || [])
    .filter((cap) => isErg(cap?.label))
    .map((cap) => ({ cap, dist: timeForDistance(cap), age: benchmarkAge(cap, now) }))
    .filter(({ dist }) => dist && dist.m === 2000 && dist.sec > 0);
  if (twoKs.length === 0) return null;
  twoKs.sort((a, b) => (b.age?.date?.getTime() || 0) - (a.age?.date?.getTime() || 0));
  const { cap, dist, age } = twoKs[0];
  return { cap, sec: dist.sec, date: age?.date || null, stale: !!age?.stale };
}
